module.exports = __webpack_public_path__ + "static/media/posicao_amamentar4.23be6c51.jpg";